import { ContentMap } from '../../types';
import { hanoiTrainStreetAndTrainNightMarketContent } from '../common/hanoi-train-street-and-train-night-market';
import { generalVietnamContent } from './general-vietnam';
import { relatedArticlesSlugsMap } from './relatedArticlesSlugsMap';
import { visaContent } from './visa';

export const vietnamArticlesContentMap: ContentMap = {
  'general-vietnam': generalVietnamContent,
  'hanoi-train-street': hanoiTrainStreetAndTrainNightMarketContent,
  visa: visaContent,
};

export const vietnamArticlesCardData = [
  {
    title: 'וייטנאם - תעודת זהות',
    description:
      'מדינה מגוונת עם היסטוריה עשירה, נופים עוצרי נשימה, תרבות מרתקת וכלכלה מתפתחת - וייטנאם היא יעד שחובה להכיר מקרוב',
    imageUrl: '/images/vietnam/general-vietnam/general-vietnam-preview.jpeg',
    date: '10.12.2023',
    readTime: '10',
    slug: 'general-vietnam',
  },
  {
    title:
      'רחוב הרכבת בהאנוי ושוק הרכבת בתאילנד - חוויות מסילה שלא תרצו לפספס!',
    description:
      'השוואה מסקרנת בין שני יעדים יוצאי דופן שבהם רכבת חולפת בין חנויות ובתי קפה - חוויה שלא תשכחו בוייטנאם ובתאילנד',
    imageUrl:
      '/images/common/train-night-market/train-night-market-preview.jpeg',
    date: '10.03.2024',
    readTime: '10',
    slug: 'hanoi-train-street',
  },
  {
    title: 'ויזה לוייטנאם',
    description:
      'כל מה שצריך לדעת על הוצאת ויזה לווייטנאם - הסברים ברורים על סוגי הוויזות, העלויות, הדרישות והטיפים הכי חשובים לפני הכניסה למדינה',
    imageUrl: '/images/vietnam/visa/visa-preview.jpeg',
    date: '10.03.2024',
    readTime: '10',
    slug: 'visa',
  },
].map((article) => ({
  ...article,
  articleLink: `/international/vietnam/article/${article.slug}`,
  relatedArticlesSlugs:
    relatedArticlesSlugsMap[
      article.slug as keyof typeof relatedArticlesSlugsMap
    ],
}));
